// Generated from SVG to Code Figma Plugin

export const BaseLineMove = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.04688 8.5V4C3.04688 3.44771 3.46995 3 3.99183 3H9.66156L12.0239 6H20.0561C20.578 6 21.001 6.4477 21.001 7V21H3.99183C3.46995 21 3.04688 20.5523 3.04688 20V16.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.69761"
    />
    <path
      d="M8.67082 10.0273L11.0332 12.5273L8.67082 15.0273"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.69761"
    />
    <path
      d="M11.0332 12.4663H3.47357H3.00109"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.69761"
    />
  </svg>
);
